import { Box, Flex, Text, Badge, Spinner, HStack, Skeleton } from "@chakra-ui/react"
import { FaTriangleExclamation, FaCircleCheck } from "react-icons/fa6"

interface AlertsBannerProps {
  headlines?: {
    totalAlerts: number
    alertsBySeverity: {
      critical: number
      warning: number
      info: number
    }
  } | null
  loading: boolean
}

function AlertsBanner({ headlines, loading }: AlertsBannerProps) {
  if (loading) {
    return (
      <Skeleton height="50px" width="100%" />
    )
  }

  if (!headlines) {
    return null
  }

  const { totalAlerts, alertsBySeverity } = headlines
  const hasCritical = alertsBySeverity.critical > 0
  const hasWarnings = alertsBySeverity.warning > 0

  const color = hasCritical ? "error" : hasWarnings ? "orange" : "green"
  const fontColor = "white"
  const borderStyle = `1px solid ${color}`

  return (
    <Box
      width="100%"
      backgroundColor={`${color}`}
      border={borderStyle}
      borderRadius="md"
      color={fontColor}
      px={6}
      py={3}
      mt={2}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" gap={3}>
          {totalAlerts > 0 ? (
            <FaTriangleExclamation
              color={color}
              size={20}
            />
          ) : (
            <FaCircleCheck color={fontColor} size={20} />
          )}

          <Text
            fontSize="md"
            fontWeight="600"
            color={fontColor}
          >
            {totalAlerts > 0
              ? `${totalAlerts} active alert${totalAlerts !== 1 ? 's' : ''} across all assets`
              : "All systems operational - no active alerts"
            }
          </Text>
        </Flex>

        {totalAlerts > 0 && (
          <HStack gap={2} fontSize={"sm"}>

            {alertsBySeverity.critical > 0 && (
              <Text>
                {alertsBySeverity.critical} Critical
              </Text>
            )}
            {alertsBySeverity.warning > 0 && (
              <Text >
                {alertsBySeverity.warning} Warning
              </Text>
            )}
            {alertsBySeverity.info > 0 && (
              <Text >
                {alertsBySeverity.info} Info
              </Text>
            )}
          </HStack>
        )}
      </Flex>
    </Box>
  )
}

export default AlertsBanner